import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@app/@core-auth/services';
import { LoginValidationMessages } from '@app/auth/models';
import { LoginFormService } from '@app/auth/services';
import { Observable } from 'rxjs';
import { LanguageSelectComponent } from '@app/@core-ui/';

@Component({
    selector: 'ngx-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LoginFormService],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  loading$: Observable<boolean>;
  form: UntypedFormGroup;
  validationMessages: LoginValidationMessages;

  public constructor(private loginForm: LoginFormService, private authService: AuthService, private router: Router) {
    this.loading$ = this.loginForm.loading$;
    this.form = this.loginForm.form;
    this.validationMessages = this.loginForm.validationMessages;
  }
  
  ngOnInit(): void {
    if (this.authService.getIsLoggedIn()) {
      this.router.navigate(['']);
    }
  }

  submit() {
    this.loginForm.submit();
  }

  ngOnDestroy() {}
}
